export default __webpack_public_path__ + "static/media/logo.adbb51a7.svg";